export default {
  res_help_title: "مساعدة ودعم المطعم",
  res_help_subtitle: "إدارة عمليات مطعمك بسهولة",

  res_profile_title: "إكمال ملف المطعم",
  res_profile_desc: "قم بتحديث بيانات المطعم",
  res_go_profile: "الملف الشخصي",

  res_dashboard_tour: "جولة لوحة التحكم",
  res_dashboard_tour_desc: "تعلم ميزات النظام",
  res_start_tour: "ابدأ الجولة",

  res_tools_title: "أدوات المطعم",
  res_tools_desc: "إدارة الأدوات والتقارير",
  res_explore_tools: "استكشاف",

  res_docs_title: "التوثيق",
  res_docs_desc: "اقرأ الدليل الكامل",
  res_view_docs: "عرض",

  res_support_title: "هل تحتاج مساعدة؟",
  res_support_desc: "نحن هنا لمساعدتك",
  res_contact_support: "اتصل بالدعم"
};